import PropTypes from 'prop-types'

import useAuthz from '../hooks/useAuthz'
import { setAccessTokenProvider } from '../services/api/apiClient'

// Registration must stay in the render body: an effect here would run after
// child layout effects and could lose the race against a view's first fetch.
const TokenProviderBridge = ({ children }) => {
  const { getAccessToken } = useAuthz()
  setAccessTokenProvider(getAccessToken)
  return children
}

TokenProviderBridge.propTypes = {
  children: PropTypes.node,
}

export default TokenProviderBridge
